<template>
<div class="Landing-page">
    <div id="carouselExample" class="carousel  mt-5 slide carousel-fade" data-bs-ride="carousel">
        <!-- Text Content Section -->
        <div class="slider-prod-banner">
            <div class="container">
                <div class="row">
                    <div class="text-content col-md-12">
                        <h6>{{ $t('home_page.hk_slogan') }}</h6>
                        <h1>Transforming Hospitality with a Seamless, Single-Platform Guest Experience</h1>
                        <p>We improve the visitor experience, bring clarity to performance data, streamline day-to-day operations, and increase revenue.</p>
                        <div class="pt-1 d-flex">
                            <router-link :to="'/contact-team'" class="nav-link p-0">
                                <button type="button" class="btn hk-btn-demo-main me-2">
                                    {{ $t("hk_all_btn.demo_btn") }}
                                    <img src="@/assets/common/arrow-circle-right.svg" alt="arrow-circle-right-svg" class="w-auto demo-svg" />
                                </button>
                            </router-link>

                            <div class="btn-group">
                                <button class="btn btn-dropdown dropdown-toggle d-flex align-items-center" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {{ $t('hk_all_btn.looking_for') }}
                                    <span class="dropdown-icon ms-2"></span>
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a class="dropdown-item" href="/enterprise"> {{ $t('hk_all_btn.looking_for_global_brand') }}</a>
                                    <a class="dropdown-item" href="/property-management-system">{{ $t('hk_all_btn.looking_for_regional_brand') }}</a>
                                    <a class="dropdown-item" href="/property-management-system">{{ $t('hk_all_btn.looking_for_independent_hotels') }}</a>
                                    <a class="dropdown-item" href="/tenant-key">{{ $t('hk_all_btn.looking_for_residential') }}</a>
                                    <a class="dropdown-item" href="/property-management-system">Hostels</a>
                                    <a class="dropdown-item" href="/retail-key">{{ $t('hk_all_btn.looking_for_food_beverage') }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Carousel Section -->
             <div class="carousel-inner ">
                    <!-- First Slide -->
                    <div class="carousel-item active " data-bs-interval="3000">
                        <picture>
                            <source srcset="@/assets/home/hero-section-1-mob.webp" media="(max-width: 768px)" alt="hotelkey | retailkey | paymentkey | pms ">
                            <img src="@/assets/home/hero-section-1.webp" class="d-block w-100 test" alt="Property Management System | HotelKey" loading="lazy">
                        </picture>
                    </div>

                    <!-- Second Slide -->
                    <div class="carousel-item" data-bs-interval="3000">
                        <picture>
                            <source srcset="@/assets/home/hero-section-2-mob.webp" media="(max-width: 768px)" alt="hotelkey | retailkey | paymentkey | pms ">
                            <img src="@/assets/home/hero-section-2.webp" class="d-block w-100" alt="Property Management System | HotelKey" loading="lazy">
                        </picture>
                    </div>

                    <!-- Third Slide -->
                    <div class="carousel-item" data-bs-interval="3000">
                        <picture>
                            <source srcset="@/assets/home/hero-section-3-mob.webp" media="(max-width: 768px)" alt="hotelkey | retailkey | paymentkey | pms ">
                            <img src="@/assets/home/hero-section-3.webp" class="d-block w-100" alt="Property Management System | HotelKey" loading="lazy">
                        </picture>
                    </div>
                </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'home-banner',
    mounted() {
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/sass/config/variables.scss";
@import "@/assets/sass/main.scss";

.btn-dropdown {
    padding: 12px 14px;
    color: #17749F;
    background: rgb(255, 255, 255);
    font-weight: 500;
    margin-top: 1rem;
    border-radius: 8px;
}
</style>
